// extracted by mini-css-extract-plugin
export default {"section":"ReportingPage_section__p7nbG","title":"ReportingPage_title__isgZl"};